module.exports = __webpack_public_path__ + "static/media/female.5b583edf.gif";